export class KalemMiktar {
    kalemId: number;
    talepEdilen: number;
    toplamMiktar: number;

    constructor(kalemId: number, talepEdilen: number, toplamMiktar: number) {
        this.kalemId = kalemId;
        this.talepEdilen = talepEdilen;
        this.toplamMiktar = toplamMiktar;
    }
}
